import React, { useEffect, useState } from 'react';

import { Col } from 'antd';

import CustomMaskedInput from 'components/MaskedInput';
import { functions } from 'helpers/functions';
import type IProduct from 'interfaces/IProduct';
import { BaseOfferTag } from 'v2/components/Shared/BaseOfferTag';
import { getCurrencySymbol } from 'v2/helpers/getCurrencySymbol';
import { useCurrencies } from 'v2/hooks/useCurrencies';
import { EProductType } from 'v2/interfaces/product';

import BlockedFieldTooltipProps from './../../../General/blockedTooltipProps';

interface IProps {
  product: IProduct;
  handleChange: any;
  onChangeRequiredFields?: any;
  loading: boolean;
}

const SinglePayment: React.FC<IProps> = ({ product, handleChange, loading }) => {
  const [, setShowErrors] = useState(false);

  const { data: currencies } = useCurrencies();

  const onChangeStates = () => {
    setShowErrors(prev => prev);
  };

  useEffect(() => {
    if (product.charge_type === 'N') {
      onChangeStates();
    }
  }, [product.charge_type]);

  useEffect(() => {
    if (!loading && product.charge_type === 'N') {
      onChangeStates();
    }
  }, [loading, product]);

  const isAlumy = product.type === EProductType.ALUMY;
  const isBlinket = product.type === EProductType.TICKET;
  const isInfo = product.type === EProductType.DIGITAL;
  const currencyCode = currencies.find(currency => currency.id === product.currency_id)?.code;
  const currencySymbol = currencyCode ? getCurrencySymbol('pt-BR', currencyCode) : '';
  const isCreatingNewVariation = product.isVariation() && !product.id;

  if (!isCreatingNewVariation && isInfo) {
    return null;
  }

  return (
    <>
      <Col xs={24} sm={12} className='sm:max-w-87.5 sm:flex-1'>
        <BlockedFieldTooltipProps partnerCod={product.cnt_partner_cod} enabled={isAlumy || isBlinket}>
          <div>
            <CustomMaskedInput
              label='Preço'
              fullWidth={true}
              disableUnderline
              id='price'
              helperText='Ex: 1.000,00'
              mask='money'
              value={functions.addMoneyMask(product.price)}
              onChange={(value: any) => handleChange('price', value)}
              startAdornment={currencySymbol}
              InputLabelProps={{
                shrink: true
              }}
              disabled={isAlumy || isBlinket}
            />
          </div>
        </BlockedFieldTooltipProps>
      </Col>
      {isInfo && (
        <Col>
          <BaseOfferTag />
        </Col>
      )}
    </>
  );
};

export default SinglePayment;
